import
  Link
from 'next/link';

interface HeroSlideProps {
  prefix: string
  title: string
  description: string
  button: string
  href: string
}

export default function HeroSlide({
  prefix, title, description, button, href
}: HeroSlideProps) {

  return (
    <div>
      <p className="text-xs sm:text-sm font-semibold uppercase tracking-widest text-white/70 mb-4 animate-fade-in">
        {prefix}
      </p>

      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-light text-white leading-tight mb-5 animate-slide-up">
        {title}
      </h1>

      <div className="w-12 h-0.5 bg-white/60 mx-auto mb-6 rounded-full" />

      <p className="text-sm sm:text-base text-white/80 leading-relaxed mb-10 max-w-lg mx-auto animate-slide-up">
        {description}
      </p>

      <Link
        href={href}
        className="inline-flex items-center gap-2.5 bg-transparent border border-white text-white font-semibold text-sm px-7 py-3.5 rounded-full hover:bg-white/10 hover:scale-105 transition-all duration-200 active:scale-[0.97] animate-scale-in"
      >
        {button}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-3.5 h-3.5 fill-current">
          <path d="M504.3 273.6l-112.1 104c-6.992 6.484-17.18 8.218-25.94 4.406c-8.758-3.812-14.42-12.45-14.42-21.1L351.9 288H32C14.33 288 .0002 273.7 .0002 255.1S14.33 224 32 224h319.9l0-72c0-9.547 5.66-18.19 14.42-22c8.754-3.809 18.95-2.075 25.94 4.41l112.1 104C514.6 247.9 514.6 264.1 504.3 273.6z" />
        </svg>
      </Link>
    </div>
  );
}
